import { Dialog } from '@mui/material';
import React from 'react';
import { ReactComponent as CrossIcon } from "../../../../../../../assets/img/svg/CrossIcon.svg"
import AButton from '../../../../common/form-fields-mui/AButton';
import styles from "../styles.module.scss"
import { useHistory } from "react-router-dom";


const CancelCollectionDialog = ({ open, closeHandler }) => {

    const history = useHistory();

    return (

        <Dialog open={open}>

            <div className={styles['dialog-padding']}>

                <div className='d-flex justify-content-between'>

                    <div className={styles['verify-details-dialog-header']}>
                        Do you want to end this payment collection?
                    </div>
                    <CrossIcon onClick={closeHandler} className={styles['dialog-cross-icon']} />

                </div>

                <div className={` my-3 ${styles['cancel-collection-dialog-sub-header']}`}>
                    Your transaction data will not be saved and will be lost. You will need to re-enter all details to initiate payment collection.
                </div>

                <div>
                    <AButton
                        variant='primary_filled'
                        className='no-ml-btn'
                        onClick={closeHandler}
                    >
                        No, Go Back
                    </AButton>

                    <AButton
                        variant='outline_danger'
                        onClick={() =>
                            history.push('/admin/paymentCollection')
                        }
                    >
                        Yes, Exit
                    </AButton>

                </div>

            </div>
        </Dialog>
    );
}

export default CancelCollectionDialog;